import React, { PropTypes } from 'react';
import { inject, observer } from 'mobx-react';
import { observable, autorun, toJS } from 'mobx';
import Form, { FormBody, TextInput } from '../../Form';
import Spinner from "../../Spinner";
import WorkOrderLogRoot from "./Log/WorkOrderLogRoot";
import WorkOrderFollower from "./Followers/WorkOrderFollower";
import moment from 'moment';
import TabBar from "../../TabBar";
import { Link } from 'react-router';
import { sort } from '../helper';

@inject('workOrderStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore', 'userStore', 'stationStore')
@observer
export default class WorkOrderView extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view` : `/monitoring/work_order/tabular/${this.props.params.id}/view`;

  @observable workOrder = null;
  @observable enableAddTicket = false;
  @observable showWindow = null;
  dispose;

  componentWillMount() {
    const { workOrderStore, workOrderStatusStore, priorityStore, maintenanceTypeStore, userStore } = this.props;

    workOrderStore.fetchWorkOrderById(this.props.params.work_order_id ? this.props.params.work_order_id : this.props.params.id);

    this.dispose = autorun(() => {
      let workOrder = workOrderStore.workOrder;

      if (!!workOrder) {
        let createdBy = userStore.findById(workOrder.created_by),
          assignedTo = userStore.findById(workOrder.assigned_to),
          maintenance_type = maintenanceTypeStore.findById(workOrder.maintenance_type),
          priority = priorityStore.findById(workOrder.priority),
          status = workOrderStatusStore.findById(workOrder.status);

        this.workOrder = {
          id: workOrder.id,
          title: workOrder.title,
          status: status && status.caption,
          station: workOrder.station,
          archived: workOrder.archived,
          priority: priority && priority.caption,
          maintenance_type: maintenance_type && maintenance_type.caption,
          created_by: createdBy && createdBy.name,
          assigned_to: assignedTo && assignedTo.name,
          creation_date: moment(workOrder.creation_date).format('YYYY-MM-DD'),
          scheduled_date: moment(workOrder.scheduled_date).format('YYYY-MM-DD'),
          completion_deadline: moment(workOrder.completion_deadline).format('YYYY-MM-DD'),
          ticket: workOrder.ticket
        };
      }
    })
  }

  componentWillUnmount() {
    this.props.workOrderStore.clearWorkOrderView();
  }

  onClickCreateTicket = e => {
    e.preventDefault();
    this.context.router.push(this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/ticket/add` : `/monitoring/work_order/tabular/${this.props.params.id}/view/ticket/add`)
  };

  onClickCreateStation = e => {
    e.preventDefault();
    this.context.router.push(this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/station/add` : `/monitoring/work_order/tabular/${this.props.params.id}/view/station/add`)
  };

  getInfoWindow = id => {
    const { workOrderStore, workOrderStatusStore, maintenanceTypeStore, priorityStore } = this.props;
    let workOrder = workOrderStore.findById(id),
      status = workOrderStatusStore.findById(workOrder.status),
      priority = priorityStore.findById(workOrder.priority),
      type = maintenanceTypeStore.findById(workOrder.maintenance_type);
    return (
      <div className='popupInfoWindow'>
        <strong>{workOrder.title}</strong><br /><br />
        <table>
          <tbody>
            <tr><th>Status</th><td>{status.caption}</td></tr>
            <tr><th>Priority</th><td>{priority.caption}</td></tr>
            <tr><th>Type</th><td>{type.caption}</td></tr>
          </tbody>
        </table>
      </div>
    )
  };

  onClickArchive = () => {
    const { params: { work_order_id, id }, workOrderStore } = this.props;
    const { notify } = this.context;
    let message = this.workOrder.archived ? 'Work Order removed from archive' : 'Work Order moved to archive';
    let { archived, station, ticket, ...others } = workOrderStore.findById(work_order_id || id).asJson;

    workOrderStore.updateItem(Object.assign({}, { id: work_order_id || id, archived: !this.workOrder.archived, ...others })).then(() => {
      workOrderStore.fetchWorkOrderById(work_order_id || id);
      this.workOrder.archived = !this.workOrder.archived;
      notify.success({ message })
    });
  };

  render() {
    const { stationStore } = this.props;

    if (!this.workOrder) return <Spinner />;
    // const {params: {id}} = this.props;
    const id = this.props.params.work_order_id || this.props.params.id;
    return (
      <div className='full-width'>
        <Form>
          <FormBody>
            <div className='inline-grid space-between'>
              <span />
              <span className='ticket-action-button' onClick={this.onClickArchive}><i className='fa fa-archive' /> {this.workOrder.archived ? 'Unarchive' : 'Archive  '}</span>
            </div>
            <div className='inline-grid space-between overflow-x-hidden'>
              <div>
                <TextInput value={this.workOrder.id} label='Work Order Number' readOnly />
                <TextInput value={this.workOrder.title} label='Work Order Title' readOnly />
                <TextInput value={this.workOrder.created_by} label='Created By' readOnly />
                <TextInput value={this.workOrder.assigned_to} label='Assigned To' readOnly />
              </div>
              <div>
                <TextInput value={this.workOrder.status} label='Status' readOnly />
                <TextInput value={this.workOrder.priority} label='Priority' readOnly />
                <TextInput value={this.workOrder.maintenance_type} label='Maintenance Type' readOnly />
                <div className='formInput flex flex-row'>
                  <label>Ticket Number</label>
                  <div className='flex v-center' style={{ margin: '-10px' }}>
                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                      {this.workOrder.ticket && sort(this.workOrder.ticket, id).map((item, i) =>
                        <li key={`work_order_ticket_${item.id}_${i}`}><div style={{ marginLeft: `${10}px`/*, position: 'absolute'*/ }} /*onMouseOver={() => this.showWindow = item.id} onMouseOut={() => this.showWindow = null}*/>
                          <a href={`#/monitoring/ticket/tabular/${item.id}/view`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '10vw', margin: 0, fontSize: '14px' }}>{item.summary}</a>
                          {/* <Link to={`/monitoring/ticket/tabular/${item.id}/view`}>{item.summary}</Link> */}
                          {/*{+this.showWindow === item.id && this.getInfoWindow(item.id)}*/}
                        </div>
                        </li>
                      )}
                    </ul>
                    <i className='fa fa-pencil pull-right' onClick={this.onClickCreateTicket} />
                  </div>
                </div>
              </div>
              <div>
                <TextInput value={this.workOrder.creation_date} label='Creation Date' readOnly />
                <TextInput value={this.workOrder.scheduled_date} label='Scheduled Date' readOnly />
                <TextInput value={this.workOrder.completion_deadline} label='Completion Deadline' readOnly />
                <div className='formInput flex flex-row'>
                  <label>Stations</label>
                  <div className='flex v-center' style={{ margin: '-10px' }}>
                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                      {this.workOrder.station && sort(this.workOrder.station, id).map((item, i) => {
                        const correspondingStation = stationStore.findById(item.id);

                        return <li key={`work_order_station_${item.id}`}>
                          <div style={{ marginLeft: `${10}px`/*, position: 'absolute'*/ }} /*onMouseOver={() => this.showWindow = item.id} onMouseOut={() => this.showWindow = null}*/>
                            {/* <Link to={`/station/${item.id}/monitoring`}>{correspondingStation ? correspondingStation.name : item.id}</Link> */}
                            <a href={`#/station/${item.id}/monitoring`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '10vw', margin: 0, fontSize: '14px' }}>{correspondingStation ? correspondingStation.name : item.id}</a>
                            {/*{+this.showWindow === item.id && this.getInfoWindow(item.id)}*/}
                          </div></li>
                      })}
                    </ul>
                    <i className='fa fa-pencil pull-right' onClick={this.onClickCreateStation} />
                  </div>
                </div>
              </div>
            </div>
          </FormBody>
        </Form>
        <br />
        <div className='ticket-list-map'>
          <div className='flex-grow overflow-x-scroll'>
            <div>
              <TabBar items={[
                { to: this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/logs` : `/monitoring/work_order/tabular/${this.props.params.id}/view/logs`, label: 'Logs' },
                { to: this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/tasks` : `/monitoring/work_order/tabular/${this.props.params.id}/view/tasks`, label: 'Tasks' },
              ]} rounded /><br />
              {this.props.children ? React.cloneElement(this.props.children, { workOrder_id: this.props.params.work_order_id ? this.props.params.work_order_id : id, slug: this.slug }) : null}
            </div>
          </div>
          <WorkOrderFollower workOrder_id={id} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderView.js